/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DepartmentsControllerFindOneQueryResponse, DepartmentsControllerFindOnePathParams, DepartmentsControllerFindOneQueryParams, DepartmentsControllerFindOne400, DepartmentsControllerFindOne401, DepartmentsControllerFindOne403, DepartmentsControllerFindOne404 } from "../../models/departmentsController/DepartmentsControllerFindOne";

function getDepartmentsControllerFindOneUrl(id: DepartmentsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/departments/${id}` as const }  
  return res
}

/**
 * @summary Get a department by ID
 * {@link /api/v1/departments/:id}
 */
export async function departmentsControllerFindOne(id: DepartmentsControllerFindOnePathParams["id"], params?: DepartmentsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DepartmentsControllerFindOneQueryResponse, ResponseErrorConfig<DepartmentsControllerFindOne400 | DepartmentsControllerFindOne401 | DepartmentsControllerFindOne403 | DepartmentsControllerFindOne404>, unknown>({ method : "GET", url : getDepartmentsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}